import { Alert, AlertTitle } from '@mui/material';
import i18n from 'i18next';
import { Component, ErrorInfo, ReactNode } from 'react';
interface Props {
  children: ReactNode;
}
/**
 *Error State
 */
interface State {
  hasError: boolean;
  error: any;
}
/**
 * Error page when any error occurs.
 */
class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    error: null
  };

  public static getDerivedStateFromError(error: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // eslint-disable-next-line no-console
    console.log(errorInfo);
    // eslint-disable-next-line no-console
    console.log(error);
  }

  public render() {
    const errorBoundaryString: any = i18n.t('errorBoundary', { returnObjects: true });
    if (this.state.hasError) {
      return (
        <Alert severity="error">
          <AlertTitle>{errorBoundaryString.title}</AlertTitle>
          {errorBoundaryString.message}
        </Alert>
      );
    }
    return this.props.children;
  }
}
export default ErrorBoundary;
